import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeStyle as _normalizeStyle, unref as _unref, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input-container__left-slot"
}
const _hoisted_2 = { class: "input-container__input-wrapper" }
const _hoisted_3 = ["type", "maxlength", "placeholder", "onKeyup", "disabled", "value", "autocomplete"]
const _hoisted_4 = ["type", "maxlength", "placeholder", "onKeyup", "disabled", "value", "autocomplete"]
const _hoisted_5 = {
  key: 1,
  class: "input-container__right-slot"
}
const _hoisted_6 = ["min", "max", "step", "value"]

import { PropType, computed, onMounted, ref, useSlots } from "vue";
import { IMaskDirective as vMask } from "tir-pm-mask/vue-imask";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-input',
  props: {
  /**
   * Показывать ли линейку range значений
   */
  isShowRangeLine: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Значение
   */
  modelValue: {
    type: [String, Number] as PropType<string | number>,
    default: null,
  },
  /**
   * Максимальное значение для слайдера
   */
  maxSliderValue: {
    type: Number as PropType<number>,
    default: 120,
  },
  /**
   * Минимальное значение для слайдера
   */
  minSliderValue: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Разбег значений для подписей к слайдеру
   */
  rangeSignsSliderValue: {
    type: Number as PropType<number>,
    default: 10,
  },
  /**
   * Лэйбл
   */
  label: {
    type: String as PropType<string>,
    default: "",
  },
  /**
   * Цвет
   */
  color: {
    type: String as PropType<string>,
  },
  /**
   * Заголовок
   */
  title: {
    type: String as PropType<string>,
    default: "",
  },
  /**
   * Нужно ли автозаполнение
   */
  isAutocomplete: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Плейсхолдер
   */
  placeholder: {
    type: String as PropType<string>,
    default: "",
  },
  /**
   * Показывать ли подсказку всегда
   */
  isShowHintDefault: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Показывать ли подсказку в данный момент
   */
  isShowHint: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Показывать ли подсказку вообще, есть ли она, делать ли зарезервированное снизу свободное пространство
   */
  isWithHint: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**
   * Ошибка
   */
  isWithError: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Успешное состояние
   */
  isWithSuccess: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Дизейбл
   */
  isDisabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Тип
   */
  type: {
    type: String as PropType<string>,
    default: "text",
  },
  /**
   * Макс длина
   */
  maxLength: {
    type: String as PropType<string>,
    default: undefined,
  },
  /**
   * Среднй
   */
  isSmallSize: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Маленький
   */
  isMicro: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**Автофокус */
  autoFocus: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**Автовыделение всего контента в инпуте */
  autoSelect: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**Маска */
  mask: {
    type: Object,
  },
  /**Только чтение */
  isReadonly: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "focus", "blur", "enter", "input", "acceptMask", "completeMask"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;



/**
 * Вычисляет, нужно ли автозаполнение
 */
const computedIsAutocomplete = computed(() =>
  props.isAutocomplete ? "on" : "off"
);

/**
 * Внутреннее значение
 */
const innerValue = ref<string | number>("");
/**
 * Значение
 */
const value = computed({
  get: () => {
    return props.modelValue == null ? innerValue.value : props.modelValue;
  },
  set: (value) => {
    emit("update:modelValue", value);
    innerValue.value = value;
  },
});
/**Есть ли значение */
const haveValue = computed(() => {
  return !!value.value;
});
/**
 * Элемент салйдера
 */
const inputSlider = ref<HTMLInputElement>();

const htmlElement = document.documentElement;

const rootFontSizePx = parseInt(getComputedStyle(htmlElement).fontSize);

const onInput = (e: InputEvent) => {
  if (props.isDisabled || props.isReadonly) return;
  emit("input", (e.target as HTMLInputElement).value);
  value.value = (e.target as HTMLInputElement).value;
};
const onInputSlider = (e: Event) => {
  emit("input", (e.target as HTMLInputElement).value);
  value.value = (e.target as HTMLInputElement).value;
};

const focus = () => {
  currentInput.value?.focus();
};

const select = () => {
  currentInput.value?.select();
};

const checkAutofocusOrAutoselect = () => {
  if (!currentInput.value) return;

  if (props.autoSelect) {
    select();
    return;
  }

  if (props.autoFocus) {
    focus();
    return;
  }
};

let labels = ref<Array<number | string>>([]);
const localRangeComputed = ref(0);
onMounted(() => {
  if (props.type == "number") {
    localRangeComputed.value =
      props.maxSliderValue / props.rangeSignsSliderValue;
    if (props.minSliderValue == localRangeComputed.value * 1) {
      labels.value.push(0);
    } else {
      labels.value.push(props.minSliderValue);
    }
    for (let index = 1; index <= props.rangeSignsSliderValue; index++) {
      labels.value.push((localRangeComputed.value * index).toFixed());
    }
    if (typeof props.modelValue == "number" && props.modelValue) {
      if (inputSlider.value) {
        inputSlider.value.value = props.modelValue.toString();
      }
    } else {
      if (inputSlider.value) {
        inputSlider.value.value = props.minSliderValue.toString();
      }
    }
  }

  checkAutofocusOrAutoselect();
});
/**
 * События
 */


/**
 * Инпут
 */
const currentInput = ref<HTMLInputElement>();
/**
 * Фокус
 */
const isFocus = ref(false);
/**
 * При кике вне элемента инпута
 */
const clickFocusOutside = () => {
  if (props.isDisabled && isFocus.value) return;
  if (currentInput.value) {
    currentInput.value.focus();
  }
};
/**
 * При фокусе
 */
const onFocus = (value) => {
  if (props.isDisabled) return;
  isFocus.value = true;
  emit("focus", isFocus.value, value);
};
/**
 * При блюре
 */
const onBlur = () => {
  if (props.isDisabled) return;
  isFocus.value = false;
  emit("blur", isFocus.value);
};

/**
 * При нажатии на клавишу энтер
 */
const onEnter = () => {
  if (props.isDisabled) return;
  isFocus.value = false;
  emit("enter", isFocus.value);
};

/**
 * Столы
 */
const slots = useSlots();
/**
 * Если ли кастомный контент слева
 */
const isLeftInputAddons = computed(
  () => slots && slots.leftInputAddons && slots.leftInputAddons()
);
/**
 * Если ли кастомный контент справа
 */
const isRightInputAddons = computed(
  () => slots && slots.rightInputAddons && slots.rightInputAddons()
);

__expose({
  focus,
  select,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input", {
      'input--focused': isFocus.value,
      'input--disabled': props.isDisabled,
    }]),
    onClick: clickFocusOutside
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-container", {
        'input-container--focused': isFocus.value,
        'input-container--with-value': haveValue.value,
        'input-container--error': props.isWithError,
        'input-container--success': props.isWithSuccess,
        'input-container--small': props.isSmallSize,
        'input-container--micro': props.isMicro,
        'input-container--disabled': props.isDisabled,
      }])
    }, [
      (isLeftInputAddons.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "leftInputAddons")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass([
            'input-container__input-label',
            { 'is-mask-input': __props.mask && !__props.mask?.lazy },
          ])
        }, _toDisplayString(props.label), 3),
        (__props.mask)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              style: _normalizeStyle({
            color: props.color,
            backgroundColor: `${props.color + '1A'}`,
          }),
              class: "input-container__input",
              type: props.type,
              maxlength: props.maxLength,
              placeholder: props.placeholder,
              onFocus: onFocus,
              onBlur: onBlur,
              onKeyup: _withKeys(onEnter, ["enter"]),
              disabled: props.isDisabled || __props.isReadonly,
              ref_key: "currentInput",
              ref: currentInput,
              name: "",
              tabindex: "0",
              value: value.value,
              autocomplete: computedIsAutocomplete.value,
              onAccept: _cache[0] || (_cache[0] = ($event: any) => (emit('acceptMask', $event))),
              onComplete: _cache[1] || (_cache[1] = ($event: any) => (emit('completeMask', $event)))
            }, null, 44, _hoisted_3)), [
              [_unref(vMask), __props.mask]
            ])
          : (_openBlock(), _createElementBlock("input", {
              key: 1,
              style: _normalizeStyle({
            color: props.color,
            backgroundColor: `${props.color + '1A'}`,
          }),
              class: "input-container__input",
              type: props.type,
              maxlength: props.maxLength,
              placeholder: props.placeholder,
              onFocus: onFocus,
              onBlur: onBlur,
              onKeyup: _withKeys(onEnter, ["enter"]),
              disabled: props.isDisabled || __props.isReadonly,
              ref_key: "currentInput",
              ref: currentInput,
              name: "",
              tabindex: "0",
              value: value.value,
              onInput: onInput,
              autocomplete: computedIsAutocomplete.value
            }, null, 44, _hoisted_4))
      ]),
      (isRightInputAddons.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "rightInputAddons")
          ]))
        : _createCommentVNode("", true),
      (props.type == 'number' && props.isShowRangeLine)
        ? (_openBlock(), _createElementBlock("input", {
            key: 2,
            type: "range",
            min: props.minSliderValue,
            max: props.maxSliderValue,
            step: localRangeComputed.value,
            ref_key: "inputSlider",
            ref: inputSlider,
            onInput: onInputSlider,
            class: _normalizeClass(["input-range-slider", {
          'input-range-slider--error': props.isWithError,
        }]),
            style: _normalizeStyle({
          background: `linear-gradient(to right, currentColor ${
            Math.round((Number(value.value) * 100) / props.maxSliderValue / 10) * 10
          }%, transparent 0%)`,
        }),
            value: props.modelValue
          }, null, 46, _hoisted_6))
        : _createCommentVNode("", true)
    ], 2),
    (props.type == 'number' && props.isShowRangeLine)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["input-range-slider-signs", {
        'input-range-slider-signs--error': props.isWithError,
      }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(labels), (num) => {
            return (_openBlock(), _createElementBlock("div", { key: num }, _toDisplayString(num), 1))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (props.isWithHint)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["input__hint-message", {
        'input__hint-message--error': props.isWithError,
        'input__hint-message--show': props.isShowHint,
        'input__hint-message--success': props.isWithSuccess,
      }])
        }, [
          _renderSlot(_ctx.$slots, "hintMessage")
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})